import * as React from 'react';

function SvgProgressApplicationProcessing(props) {
  return (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.603 18.571A7.197 7.197 0 0010.039 20H2.857A2.857 2.857 0 010 17.143V2.857A2.857 2.857 0 012.857 0h12.857a2.857 2.857 0 012.857 2.857v5.747a7.129 7.129 0 00-1.428-.858V2.857c0-.789-.64-1.428-1.429-1.428H2.857c-.789 0-1.428.64-1.428 1.428v14.286c0 .789.64 1.428 1.428 1.428h5.746zm5.683-12.857c0 .395-.32.715-.715.715H5A.714.714 0 015 5h8.571c.395 0 .715.32.715.714zm-5 3.572c0 .394-.32.714-.715.714H5a.714.714 0 110-1.429h3.571c.395 0 .715.32.715.715zM5 12.143h1.429a.714.714 0 010 1.428H5a.714.714 0 110-1.428zm9.286-3.572a5.714 5.714 0 100 11.429 5.714 5.714 0 000-11.429zm0 9.998a4.284 4.284 0 110-8.568 4.284 4.284 0 010 8.568zm1.916-6.195a.65.65 0 11.92.92l-2.829 2.827a.65.65 0 01-.92 0l-1.413-1.414a.65.65 0 11.919-.919l.954.955 2.37-2.37z" />
    </svg>
  );
}

export default SvgProgressApplicationProcessing;
